import { IState } from './CreditNotes.reducer';

export interface IActions {
    [CreditNotesActionTypes.setCreditNotesContext]?: IState['CreditNotesContext'];
    [CreditNotesActionTypes.setCreditNote]?: IState['CreditNote'];
    [CreditNotesActionTypes.setLineNumber]?: IState['LineNumber'];
    [CreditNotesActionTypes.setSummaryPanelData]?: IState['SummaryPanelData'];
    [CreditNotesActionTypes.setPreventChangeStatus]?: IState['PreventChangeStatus'];
    [CreditNotesActionTypes.setIsChangeStatusDisabled]?: IState['IsChangeStatusDisabled'];
    [CreditNotesActionTypes.setCreditNotesLookupPanelOpen]?: IState['CreditNotesLookupPanelOpen'];
    [CreditNotesActionTypes.setLHSFocusField]?: IState['LHSFocusField'];
    [CreditNotesActionTypes.setComponentLineNumber]?: IState['ComponentLineNumber'];
    [CreditNotesActionTypes.setComponentId]?: IState['ComponentId'];
    [CreditNotesActionTypes.setCreditNoteLineDetailSummary]?: IState['CreditNoteLineDetailSummary'];
}

export enum CreditNotesActionTypes {
    setCreditNotesContext = 'setCreditNotesContext',
    setCreditNote = 'setCreditNote',
    setLineNumber = 'setLineNumber',
    setSummaryPanelData = 'setSummaryPanelData',
    setIsChangeStatusDisabled = 'setIsChangeStatusDisabled',
    setPreventChangeStatus = 'setPreventChangeStatus',
    setCreditNotesLookupPanelOpen = 'setCreditNotesLookupPanelOpen',
    setComponentLineNumber = 'setComponentLineNumber',
    setCreditNoteLineDetailSummary = 'setCreditNoteLineDetailSummary',
    setComponentId = 'setComponentId',
    setLHSFocusField = 'setLHSFocusField'
}
